import React from "react";
import styled from "styled-components";
const StyledWrapper = styled.div`
  position: relative;
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
`;
const StyledPrizeText = styled.div`
  flex: 3 1 auto;
  min-width: 0;
`;
const StyledPrizeImage = styled.img`
  position: relative;
  flex: 0 1 auto;
  z-index: 2;
  top: 0.25rem;
  right: 0.5rem;
  max-height: 60px;
`;

const Wrapper = ({
  children,
  prizeImageUrl
}) => {
  return /*#__PURE__*/React.createElement(StyledWrapper, null, /*#__PURE__*/React.createElement(StyledPrizeText, null, children), /*#__PURE__*/React.createElement(StyledPrizeImage, {
    src: prizeImageUrl
  }));
};

export default Wrapper;